import dynamic from "next/dynamic";

export const DynamicContent013 = dynamic(() => import("./Content013"), {
  suspense: true,
});
